import { Braces, CalendarDays, FileDiff, ShieldCheck } from "lucide-react";
import { NavLink, Outlet } from "react-router-dom";
import { cn } from "@/lib/utils";

const links = [
  { to: "/diff", label: "Diff", icon: FileDiff },
  { to: "/json", label: "JSON", icon: Braces },
  { to: "/nric-fin", label: "NRIC / FIN", icon: ShieldCheck },
  { to: "/days-between", label: "Days Between", icon: CalendarDays },
];

export function AppShell() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur dark:border-slate-800 dark:bg-slate-950/90">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <NavLink to="/diff" className="font-semibold tracking-tight">
            Common Util{" "}
            <span className="text-sky-700 dark:text-sky-300">
              / private by default
            </span>
          </NavLink>
          <nav aria-label="Utilities" className="flex gap-1 overflow-x-auto">
            {links.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  cn(
                    "inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors",
                    isActive
                      ? "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-200"
                      : "text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800",
                  )
                }
              >
                <Icon size={16} aria-hidden="true" />
                {label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main id="main-content" className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <Outlet />
      </main>
    </div>
  );
}
